import { z } from "zod";

// Normalizes blank/whitespace-only date strings to null so downstream `??`
// scheduled-date fallbacks (see shipment-results.tsx) engage correctly. Only
// `null`/`undefined` are treated as "nullish" by `??`, so a blank string from
// the API would otherwise slip through as a truthy-but-empty value.
const nullableDateStringSchema = z
	.string()
	.nullish()
	.transform((value) => (value != null && value.trim() === "" ? null : value));

export const loadTrackingEventSchema = z.object({
	locationDateTime: z.string(),
	status: z.string().nullish(),
	city: z.string().nullish(),
	state: z.string().nullish(),
	distance: z.number().int().nullish(),
	latitude: z.number().nullish(),
	longitude: z.number().nullish(),
});

export const loadTrackingStopSchema = z.object({
	sortOrder: z.number().nullish(),
	stopType: z.string(),
	city: z.string().nullish(),
	state: z.string().nullish(),
	zipCode: z.string().nullish(),
	latitude: z.number().nullish(),
	longitude: z.number().nullish(),
	stopDate: z.string().nullish(),
});

export const loadTrackingResponseSchema = z.object({
	trackingEvents: z.array(loadTrackingEventSchema),
	stops: z.array(loadTrackingStopSchema),
	mode: z.string().nullish(),
	status: z.string().nullish(),
	message: z.string().nullish(),
	proNumber: z.string().nullish(),
	hideTracking: z.boolean().nullish(),
	pickedUpDate: nullableDateStringSchema,
	deliveredDate: nullableDateStringSchema,
});

export type LoadTrackingEvent = z.infer<typeof loadTrackingEventSchema>;
export type LoadTrackingStop = z.infer<typeof loadTrackingStopSchema>;
export type LoadTrackingResponse = z.infer<typeof loadTrackingResponseSchema>;
